import React, { createContext, useEffect, useState } from "react";
import { NamedProperty } from "sprint-common-web";

import { GetOriginatorsLookupResponse } from "../../api/delivery-api/originators/GetOriginatorsLookupResponse";
import { useDeliveryApi } from "../../api/delivery-api/useDeliveryApi";

interface IOriginatorsDataContext {
    originators: Originator[];
    isLoading: boolean;
}

export type Originator = NamedProperty;

export const OriginatorsDataContext = createContext<IOriginatorsDataContext>({} as IOriginatorsDataContext);

type OriginatorsDataProviderProps = React.PropsWithChildren<unknown>;

export const OriginatorsDataProvider: React.FunctionComponent<OriginatorsDataProviderProps> = ({
    children
}: OriginatorsDataProviderProps) => {
    const [originators, setOriginators] = useState<Originator[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const { getOriginatorsLookup } = useDeliveryApi();

    useEffect(() => {
        setIsLoading(true);
        getOriginatorsLookup().then((response: GetOriginatorsLookupResponse) => {
            setOriginators(response.items);
            setIsLoading(false);
        });
    }, []);

    return (
        <OriginatorsDataContext.Provider value={{ originators, isLoading }}>{children}</OriginatorsDataContext.Provider>
    );
};
